import { render } from "./data-page.vue?vue&type=template&id=f8e1cb36&scoped=true"
import script from "./data-page.vue?vue&type=script&lang=js"
export * from "./data-page.vue?vue&type=script&lang=js"

import "./data-page.vue?vue&type=style&index=0&id=f8e1cb36&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e1cb36"]])

export default __exports__